import React from 'react'
import { Icon } from "@material-ui/core";
import DiscordLogo from './Discord-Logo-Black.svg'

export const DiscordIcon = () => (
    React.createElement(Icon, null
        , React.createElement('img', { src: DiscordLogo, alt: "", height: 25, width: 25,})
    )
)